import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';


@Component({
  selector: 'app-xref-cut-off-schedule-date-picker-modal',
  templateUrl: './xref-cut-off-schedule-date-picker-modal.component.pug',
  styleUrls: ['./xref-cut-off-schedule-date-picker-modal.component.scss'],
  standalone: false
})
export class XrefCutOffScheduleDatePickerModalComponent implements OnInit {

  public saveClick: EventEmitter<any> = new EventEmitter<any>()
  public cancelClick: EventEmitter<any> = new EventEmitter<any>()

  @Input() checkType: any = ''
  @Input() selectedCutOffExpiry: any = ''
  @Input() selectedScheduleExpiry: any = ''
  bsValue = new Date();
  config = { showWeekNumbers: false, selectWeek: true };
  minDate = new Date();
  selected = {
    date: '',
    time: '',
    timeZone: ''
  }
  defaultSelectedDate = ''
  showWarningForCutOffDate = false
  showWarningForSchedule = false
  warningForSelectedDateLessThan24Hrs = false
  showWarningForNowLessThan24Hrs = false
  timeZones: any[] = []
  time12HourFormat = ConstantsService.TimeHalfHourSpan;
  previousTimeZone = '';
  formats = ['YYYY/MM/DD h:mm A', 'DD/MM/YYYY h:mm A', 'MM/DD/YYYY h:mm A'];
  constructor(public _bsModalRef: BsModalRef,private permissions: PermissionsService) {
    this.minDate.setDate(this.minDate.getDate());
  }
  ngOnInit(): void {
    this.setSelectedDateTimezone()
  }
  setSelectedDateTimezone() {
    this.timeZones = moment['tz'].names()
    this.selected.timeZone = this.selectedCutOffExpiry?.timeZone;
    this.previousTimeZone = this.selected.timeZone;
    const now = moment().tz(this.selected.timeZone);
    this.addMinutesToDate(now, 30)
    if(this.checkType==ConstantsService.CUT_OFF) now.add(24, "h");
    this.selected.time = now.format("h:mm A")
    this.selected.date = now.format('DD/MM/YYYY')
    this.bsValue = new Date(moment().tz(this.selected.timeZone).format('MM/DD/YYYY'));
    this.setMinDate()
    if (this.checkType === ConstantsService.CUT_OFF) {
      if (this.selectedCutOffExpiry?.date) {
        this.selected.date = this.selectedCutOffExpiry?.date
        this.setCutOffDateTime()
      }
    }
    else {
      if (this.selectedScheduleExpiry?.date) {
        this.selected.date = this.selectedScheduleExpiry?.date;
        this.setScheduledDateTime();
      }
    }
  }

  setScheduledDateTime(){
    const dateTimeStr = `${this.selectedScheduleExpiry.date} ${this.selectedScheduleExpiry.time}`;
    let momentObj = moment.tz(dateTimeStr, this.formats, this.selectedScheduleExpiry.timeZone);
    let isAfter = momentObj.isAfter(moment().tz(this.selected.timeZone))
    if(!isAfter){
      momentObj = moment().tz(this.selected.timeZone)
    }
    momentObj =  this.addMinutesToDate(momentObj, 30);
    this.bsValue = new Date(momentObj.format('MM/DD/YYYY'));
    this.selected.time = momentObj.format("h:mm A");
  }

  setCutOffDateTime(){
    const dateTimeStr = `${this.selectedCutOffExpiry.date} ${this.selectedCutOffExpiry.time}`

    let momentObj = moment.tz(dateTimeStr, this.formats, this.selected.timeZone);
    momentObj =  this.addMinutesToDate(momentObj, 30);

    this.bsValue = new Date(momentObj.format('MM/DD/YYYY'));
    this.selected.time = momentObj.format("h:mm A")
  }

  adjustTimeSelectionIfSameDay() {
    // Current time checker for Schedule selection atm.
    if (this.checkType === ConstantsService.SCHEDULE) {
      // Get current date
      let now;
      now = moment().tz(this.selected.timeZone);

      if (this.selected.date == now.format('DD/MM/YYYY'))
      {
        this.time12HourFormat = ConstantsService.TimeHalfHourSpan;
        // If date is same as current day, filter the time selection where you could only pick after the current time
        this.time12HourFormat = this.time12HourFormat.filter(
          (selection, index) => (
            String(~~((index * 30) / 60)).padStart(2, '0') + String((index * 30) % 60).padStart(2, '0') > now.tz(this.selected.timeZone).format('HHmm')
          )
        )
        if(!this.time12HourFormat.map(a=>a.value).includes(this.selected.time))
        {
          // If selected time is not in filtered time selection, default to first value of the list.
          this.selected.time = this.time12HourFormat[0].value;
        }
      }
      // Restore time selection to default choices if selected date is not the same as current date.
      else{
        this.time12HourFormat = ConstantsService.TimeHalfHourSpan;
      }
    }
  }

  dateChange(selectedDate) {
    this.selected.date = moment(selectedDate).format('DD/MM/YYYY')
    this.adjustTimeSelectionIfSameDay();
    this.validateDateAndTime()
  }
  selectedTimeSpan() {
    this.adjustTimeSelectionIfSameDay();
    this.validateDateAndTime()
  }
  validateDateAndTime() {
    if (this.selected.date && this.selected.time) {
      if (this.checkType === ConstantsService.CUT_OFF) {
        if (!this.isBefore24Hours()){
          this.showWarningForNowLessThan24Hrs = true
          this.warningForSelectedDateLessThan24Hrs = false
          this.showWarningForCutOffDate = false
        }
        else if (!this.isWithIn24Hours() && this.selectedScheduleExpiry.date && this.selectedScheduleExpiry.time) {
          this.showWarningForNowLessThan24Hrs = false
          this.warningForSelectedDateLessThan24Hrs = false
          this.showWarningForCutOffDate = !this.isDateTimeValid(this.checkType)
        }
        else {
          this.showWarningForNowLessThan24Hrs = false
          this.showWarningForCutOffDate = false
          this.warningForSelectedDateLessThan24Hrs = this.isWithIn24Hours()
        }
      }
      if (this.checkType === ConstantsService.SCHEDULE) {
        if (!this.isBefore24Hours()) {
          this.warningForSelectedDateLessThan24Hrs = false
          this.showWarningForSchedule = false
        }
        else if (!this.isWithIn24Hours() && this.selectedCutOffExpiry.date && this.selectedCutOffExpiry.time) {
          this.warningForSelectedDateLessThan24Hrs = false
          this.showWarningForSchedule = this.isDateTimeValid(this.checkType)
        }
        else {
          this.showWarningForNowLessThan24Hrs = false
          this.showWarningForSchedule = false
          this.warningForSelectedDateLessThan24Hrs = this.isWithIn24Hours()
        }
        if (!this.isBefore24Hours()) {
          if (this.selectedCutOffExpiry.date && this.selectedCutOffExpiry.time) {
            let selectedCutOffDateTime = moment(`${this.selectedCutOffExpiry.date} ${this.selectedCutOffExpiry.time}`, "DD-MM-YYYY HH:mm a")
            let selectedScheduleDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
            let selectedTz = moment.tz(selectedScheduleDateTime.clone(), this.selected.timeZone)
            let selectedCutOffTz = moment.tz(selectedCutOffDateTime.clone(), this.selectedCutOffExpiry.timeZone)
            selectedTz.add({ hours: 24 })
            let selectedTzFormated = moment(selectedTz.format("DD-MM-YYYY HH:mm a"), "DD-MM-YYYY HH:mm a")
            let selectedCutOffTzFormated = moment(selectedCutOffTz.format("DD-MM-YYYY HH:mm a"), "DD-MM-YYYY HH:mm a")
            this.warningForSelectedDateLessThan24Hrs = selectedCutOffTzFormated.isBefore(selectedTzFormated)
          }
        }
      }
    }
  }
  isBefore24Hours() {
    let selectedDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
    let now = moment()
    now.add({ hours: 24 })
    now = moment.tz(now, this.selected.timeZone)
    let nowFormated = now.format("DD-MM-YYYY HH:mm a")
    let selectedDateTimeFormated = selectedDateTime.format("DD-MM-YYYY HH:mm a")
    return (moment(nowFormated, 'DD-MM-YYYY HH:mm a')
      .isBefore(moment(selectedDateTimeFormated, 'DD-MM-YYYY HH:mm a')) ||
      moment(nowFormated, 'DD-MM-YYYY HH:mm a')
      .isSame(moment(selectedDateTimeFormated, 'DD-MM-YYYY HH:mm a'))
      )
  }

  isWithIn24Hours() {
    if (this.checkType === ConstantsService.CUT_OFF) {
      const selectedDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
      let scheduleTime = moment(`${this.selectedScheduleExpiry.date} ${this.selectedScheduleExpiry.time}`, "DD-MM-YYYY HH:mm a")
      let scheduleAfter24 = scheduleTime.clone()
      let scheduleAfter24Tz = moment.tz(scheduleAfter24, this.selectedScheduleExpiry.timeZone)
      scheduleAfter24Tz.add({ hours: 24 })
      scheduleAfter24Tz.format("DD MMM YYYY HH:mm a")
      return (selectedDateTime.isAfter(scheduleTime) && selectedDateTime.isBefore(scheduleAfter24Tz)) || selectedDateTime.isSame(scheduleAfter24Tz)
    }

    else if (this.checkType === ConstantsService.SCHEDULE) {
      const selectedDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
      let cutOffDateTime = moment(`${this.selectedCutOffExpiry.date} ${this.selectedCutOffExpiry.time}`, "DD-MM-YYYY HH:mm a")
      let cutOffBefore24 = moment.tz(cutOffDateTime.clone(),this.selectedCutOffExpiry.timeZone)
      let selectedDateTimeTz = moment.tz(selectedDateTime, this.selected.timeZone)
      cutOffBefore24.subtract({ hours: 24 })
      return (moment(selectedDateTimeTz.format("DD MMM YYYY HH:mm a"), "DD MMM YYYY HH:mm a")
        .isAfter(moment(cutOffBefore24.format("DD MMM YYYY HH:mm a"), "DD MMM YYYY HH:mm a")) ||
        selectedDateTimeTz.isSame(cutOffDateTime))
    }
    return false
  }

  isDateTimeValid(checkType) {
    if (checkType === ConstantsService.CUT_OFF) {
      const selectedDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
      const scheduleDateTime = moment(`${this.selectedScheduleExpiry.date} ${this.selectedScheduleExpiry.time}`, "DD-MM-YYYY HH:mm a")
      return selectedDateTime.isAfter(scheduleDateTime)
    }
    if (checkType === ConstantsService.SCHEDULE) {
      const selectedDateTime = moment(`${this.selected.date} ${this.selected.time}`, "DD-MM-YYYY HH:mm a")
      const expiryDateTime = moment(`${this.selectedCutOffExpiry.date} ${this.selectedCutOffExpiry.time}`, "DD-MM-YYYY HH:mm a")
      return selectedDateTime.isAfter(expiryDateTime)
    }
    return false
  }


  saveModal() {
    let payload = {
      time: this.selected.time,
      date: this.selected.date,
      timeZone: this.selected.timeZone,
      checkType: this.checkType
    }
    this.saveClick.emit({ data: payload });
    this._bsModalRef.hide();
  }
  closeModal() {
    this.cancelClick.emit({checkType: this.checkType })
    this._bsModalRef.hide();
  }
  validateTimeZone() {
    if (this.selected.timeZone) {
      this.onChangeFormat()
      this.validateDateAndTime()
    }
  }

  onChangeFormat(){
    const dateTimeStr = `${this.selected.date} ${this.selected.time}`
    let momentObj = moment.tz(dateTimeStr, this.formats, this.previousTimeZone)
    momentObj = momentObj.clone().tz(this.selected.timeZone)

    momentObj = this.addMinutesToDate(momentObj, 30);
    this.selected.time = momentObj.format("h:mm A");
    this.selected.date = momentObj.format('DD/MM/YYYY');

    this.bsValue = new Date(momentObj.format('MM/DD/YYYY'));

    this.previousTimeZone = this.selected.timeZone;
    this.setMinDate();
  }

  setMinDate(){
    let tempMinDate =  moment().tz(this.selected.timeZone);
    tempMinDate = this.addMinutesToDate(tempMinDate, 30);

    this.minDate.setDate(
      new Date(tempMinDate.format('MM/DD/YYYY')).getDate()
    );
  }

  addMinutesToDate(date, interval){
    const minutesObj = date.minutes();
    const remainder = minutesObj % interval
    if(remainder !==0){
      const diffObj = interval - remainder
      date.add(diffObj, "m");
    }
    return date
  }
}
